<template>
    <div class="d-flex justify-content-between align-items-center pb-3 pt-3">
        <a
            href="https://apps.apple.com/jp/app/le-pegue/id878836245?l=es"
            target="_blank"
        >
            <img src="/images/appstore.png" class="img-fluid store-img" />
        </a>
        <a
            href="https://play.google.com/store/apps/details?id=gt.com.cs.lepegue&hl=es_US&gl=US"
            target="_blank"
        >
            <img src="/images/playstore.png" class="img-fluid store-img" />
        </a>
        <a
            href="https://appgallery.huawei.com/app/C107052571"
            target="_blank"
        >
            <img src="/images/huawei.png" class="img-fluid store-img" />
        </a>
    </div>
</template>

<style scoped>
.store-img {
    height: 40px;
    width: auto;
    object-fit: contain;
}
</style>
